import Fuse from 'fuse.js';

export const SEARCH_OPTIONS = {
  distance: 100,
  location: 0,
  keys: ['name'],
  useExtendedSearch: true, // enables advanced search features for non-alphanumeric characters
  shouldSort: true, // Sort by match score to prioritize exact/closer matches
  threshold: 0.15, // Slightly more lenient than 0.1 to catch partial matches, but sorted by relevance
};

export const INITIAL_RESULTS_LIMIT = 20;

/**
 * Creates a Fuse.js search instance with optimized settings for search menus
 * @param {Array} items - Array of items to search through
 * @param {Object} options - Optional custom Fuse.js options to override defaults
 * @returns {Fuse} Configured Fuse.js instance
 */
export function createSearchInstance(items, options = {}) {
  return new Fuse(items, { ...SEARCH_OPTIONS, ...options });
}
